import { l } from '@locale/setupI18n';
import { TrancheConditionsCorkscrew } from '../hooks/useIRRHurdleCalculationsData';

export const calculateYearEntries = (
  groupedByConditionAndExitDate: TrancheConditionsCorkscrew
): Record<string, number> => {
  const allExitDates = new Map<string, number>();

  for (const condition of Object.values(groupedByConditionAndExitDate)) {
    for (const [exitDate, periods] of Object.entries(condition.exitDates ?? {})) {
      const count = Array.isArray(periods) ? periods.length : 0;
      allExitDates.set(exitDate, Math.max(allExitDates.get(exitDate) ?? 0, count));
    }
  }

  const sortedEntries = [...allExitDates.entries()].sort(([a], [b]) => {
    if (a === l('_Historic')) {
      return -1;
    }
    if (b === l('_Historic')) {
      return 1;
    }
    return new Date(a).getTime() - new Date(b).getTime();
  });

  return Object.fromEntries(sortedEntries);
};
